import { render } from "./SubTitle.vue?vue&type=template&id=30dba28a&scoped=true"
import script from "./SubTitle.vue?vue&type=script&lang=js"
export * from "./SubTitle.vue?vue&type=script&lang=js"

import "./SubTitle.vue?vue&type=style&index=0&id=30dba28a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30dba28a"]])

export default __exports__